
import { useRouter } from 'vue-router'
import Button from '@/components/elements/Button.vue'

export default {
  components: {
    Button
  },
  setup() {
    const router = useRouter()

    const toTop = () => {
      router.push({ path: '/' })
    }

    return {
      toTop
    }
  }
}
